import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchCarerStudents(payload) {
  return { type: actionTypes.FETCH_CARER_STUDENTS, payload };
}
export function fetchCarerStudentsSuccess(payload) {
  console.log(payload)
  const byId = keyBy(payload, (post) => (post.STUDENT_NUMBER.toString() + 'S'));
  return { type: actionTypes.FETCH_CARER_STUDENTS_SUCCESS, payload: { byId } };
}
export function fetchAbsences(payload) {
  return { type: actionTypes.FETCH_ABSENCES, payload };
}
export function fetchAbsencesSuccess(payload) {
  // console.log('absences....', payload)
  const byId = keyBy(payload, (post) => (post.DAILY_ATTENDANCE_ID.toString() + 'A'));
  return { type: actionTypes.FETCH_ABSENCES_SUCCESS, payload: { byId } };
}
export function fetchAbsencePercentage(payload) {
  return { type: actionTypes.FETCH_ABSENCE_PERCENTAGE, payload };
}
export function fetchAbsencePercentageSuccess(payload) {
  // console.log('percentage....', payload)
  const byId = keyBy(payload, (post) => (post.STUDENT_NUMBER));
  return { type: actionTypes.FETCH_ABSENCE_PERCENTAGE_SUCCESS, payload: { byId } };
}
export function fetchStudentInfo(payload) {
  return { type: actionTypes.FETCH_STUDENT_INFO, payload };
}
export function fetchStudentInfoSuccess(payload) {
  const byId = keyBy(payload, (post) => (post.STUDENT_NUMBER));
  return { type: actionTypes.FETCH_STUDENT_INFO_SUCCESS, payload: { byId } };
}
export function sendAbsentEmail(payload) {
  return { type: actionTypes.SEND_ABSENT_EMAIL, payload };
}
export function sendAbsentEmailSuccess(payload) {
  return { type: actionTypes.SEND_ABSENT_EMAIL_SUCCESS, payload };
}
export function saveAbsenceReason(payload) {
  return { type: actionTypes.SAVE_ABSENCE_REASON, payload };
}
export function saveAbsenceReasonSuccess(payload) {
  return { type: actionTypes.SAVE_ABSENCE_REASON_SUCCESS, payload };
}